import React, { useCallback, useEffect } from 'react';
import { Redirect } from 'react-router-dom'; // Import Redirect
import { MainContainer, MainContent, HeaderChat, Profile } from './styles';
import Conversations from '../conversations';
import { useConversation } from '../../hooks/conversation';
import { useMain } from '../../hooks/main';
import Groups from '../groups';
import { getServerSentEventPath } from '../../storage';
import { REACT_APP_ENABLE_SERVERSENTEVENT } from '../../config';
import { useChatMessages } from '../../hooks/chat';
import {
  startSSEConnection,
  closeSSEConnection,
} from '../../services/sseManager';
import { useGroups } from '../../hooks/groups';

const Main = () => {
  const { GetUserConversations, setHasCall, setSSEConnectionActive } =
    useConversation();
  const { setHasUpdate } = useChatMessages();
  const { page, setPage } = useMain();
  const handleChange = useCallback(
    (event, value) => {
      setPage(value);
    },
    [setPage]
  );
  const { reloadGroups } = useGroups();

  // if identification id not exist => return to login page
  const id = localStorage.getItem('@Squre:IdentificationId');

  // useEffect(() => {
  //   const receiverId = localStorage.getItem('@Squre:IdentificationId');

  //   if (receiverId) {
  //     startSSEConnection({
  //       receiverId,
  //       onOpen: () => setSSEConnectionActive(true),
  //       onMessage: async (data) => {
  //         try {
  //           console.log('Received SSE data:', data);

  //           await GetUserConversations();

  //           if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true') {
  //             setHasUpdate((prev) => (prev === 0 ? 1 : 0));
  //           }

  //           if (data === 'Call All' || data === 'Call to only this User') {
  //             setHasCall((prev) => (prev === 0 ? 1 : 0));
  //           }
  //         } catch (err) {
  //           console.error('SSE message handler failed:', err);
  //         }
  //       },
  //       onError: () => setSSEConnectionActive(false),
  //     });
  //   }
  // }, []);

  useEffect(() => {
    const receiverId = localStorage.getItem('@Squre:IdentificationId');

    if (REACT_APP_ENABLE_SERVERSENTEVENT === 'true' && receiverId) {
      startSSEConnection({
        receiverId,
        onOpen: () => setSSEConnectionActive(true),
        onMessage: async (data) => {
          try {
            console.log('Received SSE data:', data);

            await GetUserConversations();

            setHasUpdate((prev) => (prev === 0 ? 1 : 0));

            const staffInfoTriggers = [
              'send group message to this user',
              'addremovemembertogroupevent',
            ];

            if (staffInfoTriggers.includes(data?.toLowerCase())) {
              await reloadGroups();
            }

            if (data === 'Call All' || data === 'Call to only this User') {
              setHasCall((prev) => (prev === 0 ? 1 : 0));
            }
          } catch (err) {
            console.error('SSE message handler failed:', err);
          }
        },
        onError: () => setSSEConnectionActive(false),
      });
    }
  }, []);

  // Check BEFORE rendering anything
  if (!id) {
    return <Redirect to="/" />; // Clean React Router redirect without render crashes
  }

  return (
    <MainContainer>
      <MainContent>
        <Conversations />
      </MainContent>
    </MainContainer>
  );
};

export default Main;
